// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { z } from 'zod';
export const fermentationImageId = (z.number());
export const fermentationImage = z.object({
    id: fermentationImageId,
    fermentation_id: fermentationId.nullable(),
    image_id: z.string().nullable(),
});
export const fermentationImageInitializer = z.object({
    id: fermentationImageId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    image_id: z.string().optional().nullable(),
});
export const fermentationImageMutator = z.object({
    id: fermentationImageId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    image_id: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationImage.js.map